// extracted by mini-css-extract-plugin
export default {"accordionSummary":"DropDown_accordionSummary__K1cWM","accordionDetails":"DropDown_accordionDetails__O7J9k"};